<template>
  <div v-if="!isReadOnly" class="vueforms-textareafield" :style="style">
    <hy-textarea ref="textareaElement" type="text" v-model="attribute.ref.value as string" :rows="rows" :height="height"  v-bind="$attrs" :maxLength="maxLengthDBAndTag" :placeholder="placeholder"></hy-textarea>
    <div v-if="minLength || maxLength" class="vueforms-textareafield-hint">
      <div v-if="minLength && !isReadOnly" style="text-align: left;" >
        <span> {{ minLengthText }} {{ minLength }}</span>
      </div>
      <div v-if="maxLength && !isReadOnly" style="text-align: right;" >
        <span :style="{ color: hasLengthError ? 'red': null }">{{ (attribute.value as string)?.length ?? 0}}</span> / {{maxLength}}
      </div>
    </div>
  </div>
  <div v-else-if="attribute.ref.value" class="readOnlyClassTextArea vueforms-textareafield"  v-bind="$attrs" v-text="attribute.ref.value"></div>
  <div class="readOnlyClassTextArea vueforms-textareafield" v-else>&ZeroWidthSpace;{{ nullDisplayValue }}</div> <!-- wenn attribute ungesetzt ist stelle Whitespace dar, damit regulärere Platz reserviert wird-->
</template>

<script lang="ts">
import { computed, onMounted, shallowRef, watchEffect, nextTick, ShallowRef } from "vue";
import Attribute from "../../xmlrdb-data/Attribute"
import HyTextarea from "../../basic-components/HyTextarea.vue";
import { getDefaultTranslationProvider } from "../../translation/TranslationProvider";
export default {
	
  name: "textareaField",
  props: {
    attribute: Attribute,
    isReadOnly: Boolean,
    style: [String, Object],
    placeholder: String,
    nullDisplayValue: { type: String, default: "" },
  },
  inheritAttrs: false,
  // Steuert in der Attribute - Komponente ob das erzeugte Label als Click-Label für die Input-Komponente agieren soll
  // clickableAttributeLabel: true, 
  clickableContainer: true,
  components: {
    HyTextarea
  },
  setup(props) {
    const textareaElement: ShallowRef<InstanceType<typeof HyTextarea>> = shallowRef();

    const translationProvider = getDefaultTranslationProvider();
    let vm = {
      textareaElement,
      maxLength: computed(()=>{ 
        return props.attribute.metadata.tagValueByName("maxLength") ? parseInt(props.attribute.metadata.tagValueByName("maxLength"), 10) : undefined;
      }),
      maxLengthDBAndTag: computed(()=>{ 
        return props.attribute.metadata.maxLength() ? props.attribute.metadata.maxLength() : undefined;
      }),
      minLength: computed(() => {
        return props.attribute.metadata.minLength() ? props.attribute.metadata.minLength() : undefined;
      }),
      rows: computed(()=>{ 
        return props.attribute.metadata.tagValueByName("FieldHeight") ? props.attribute.metadata.tagValueByName("FieldHeight") : undefined;
      }),
      height: computed(()=>{ 
        return props.attribute.metadata.tagValueByName("FieldHeight") ? "auto" : undefined;
      }),

      minLengthText: computed(() => {
        if(!translationProvider)
          return "min. Länge: ";
        return translationProvider.getLabelString("TextareaField_minLength");
      }),

      hasLengthError: computed(() => {
        if(!props.attribute)
          return false;

        const minLength = props.attribute.metadata.minLength();
        const maxLength = props.attribute.metadata.maxLength();
        const valueLength = (props.attribute.ref.value as string)?.length ?? 0;

        return (minLength && valueLength < minLength) || (maxLength && valueLength > maxLength);
      }),
      //attributex : props.attribute
    }
    
    return vm;
  }
}

</script>

<style lang="scss" scoped>
textarea {
  resize: vertical;
  box-sizing: border-box;
  width: 100%; /* sollte das Probleme mit Scrollbalken verursachen bitte scoped scss in der betroffenen Komponente definieren */
}

.readOnlyClassTextArea{
  white-space: pre-wrap;
}

.vueforms-textareafield-hint {
  display: flex;
  justify-content: space-between;
  & > div {
    flex-grow: 1;
  }
}
</style>